export const GIFT_HOSPITALITY_DONATION_SECTION_KEYS = {
  requestDetails: 'gift_hospitality_donation_uk_request_details',
  approval: 'gift_hospitality_donation_uk_approval',
} as const;

export const GIFT_HOSPITALITY_DONATION_SECTION_TITLES = {
  requestDetails: 'Request Details',
  giftHospitalityDonationDetails: 'Gift, Hospitality or Donation',
  approval: 'Approval',
} as const;

export const PARTY_DETAILS_GRID_KEY = 'partyDetails';

/** Form-level flag: true after Yes on additionalClientDetailsRequired, false after No. */
export const PARTY_DETAILS_ADD_MORE_KEY = 'partyDetailsAddMore';

export const PARTY_DETAILS_DEFAULT_MAX_ROWS = 1;

export const PARTY_DETAILS_MAX_ROWS = 7;

export const ADDITIONAL_CLIENT_DETAILS_VALUE = 'additionalClientDetailsRequired';

export const ADDITIONAL_CLIENT_DETAILS_NO_VALUE = 'no';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const isAdditionalClientDetailsRequired = (value: unknown): boolean => {
  if (value === true || value === ADDITIONAL_CLIENT_DETAILS_VALUE) {
    return true;
  }

  if (!Array.isArray(value)) {
    return false;
  }

  return value.some((item) => {
    if (item === true || item === ADDITIONAL_CLIENT_DETAILS_VALUE) {
      return true;
    }

    return isRecord(item) && item.value === ADDITIONAL_CLIENT_DETAILS_VALUE;
  });
};

export const getPartyDetailsMaxRows = (
  additionalClientDetailsRequired: unknown
): number =>
  isAdditionalClientDetailsRequired(additionalClientDetailsRequired)
    ? PARTY_DETAILS_MAX_ROWS
    : PARTY_DETAILS_DEFAULT_MAX_ROWS;

export const getPartyDetailsGridKey = (givenOrReceivedBy: unknown): string => {
  if (givenOrReceivedBy === 'existingClient') {
    return `${PARTY_DETAILS_GRID_KEY}_existingClient`;
  }
  if (givenOrReceivedBy === 'prospectiveClient') {
    return `${PARTY_DETAILS_GRID_KEY}_prospectiveClient`;
  }
  if (
    givenOrReceivedBy === 'otherThirdParty' ||
    givenOrReceivedBy === 'supplier' ||
    givenOrReceivedBy === 'thirdParty'
  ) {
    return `${PARTY_DETAILS_GRID_KEY}_thirdParty`;
  }
  return PARTY_DETAILS_GRID_KEY;
};

export const INDIVIDUAL_CLIENT_TOOLTIP =
  'If the client is an individual(s) rather than an organisation, please enter N/A';
